module.exports = "../fonts/HelveticaNeueLTW01-45Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-45Light.ttf
// module id = 1kGX
// module chunks = 1